import SelectedProductSizesTable from './SelectedProductSizesTable';

export default SelectedProductSizesTable;
